import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';

import React from 'react';
import { Router, Link, withRouter, browserHistory } from 'react-router';
import moment from 'moment';
import Moment from 'react-moment';
import MgfForm from '../common/mgfForm';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Tracker } from 'meteor/tracker';
import { Flights } from '../../collections/flights/flights';

import {
  BPanel,
  Table,
  Button,
  Form,
  FormGroup,
  Col,
  Checkbox,
  ControlLabel,
  FormControl,
  Breadcrumb,
  BreadcrumbItem
} from '@sketchpixy/rubix';

import { Reactive } from '../common/Reactive.mixin';
var DatePicker = require("react-bootstrap-date-picker");

@Reactive({
	subscriptions: ["montgolfieres", "flights"]
})
@withRouter
export default class MontgolfiereViewPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	    //set start and ending date :
	    this.state.startDate = moment().startOf('year').format();
	    this.state.endDate = moment().format();
	}


  	componentWillReceiveProps(nextProps) {
		if (nextProps.isReady && !this.props.isReady) {
			this.setState({
    			flights: Flights.find({montgolfiereId: this.props.params.id, createdAt:{ $gte: moment(this.state.startDate).toDate() }, createdAt: { $lte: moment(this.state.endDate).toDate() }}, {sort: {date: 1}}).fetch().reverse(),
			});
		}
	}

	changeDate() {
		this.setState({
			flights: Flights.find({pilotId: Meteor.user()._id, createdAt:{ $gt: moment(this.state.startDate).toDate() }, createdAt: { $lt: moment(this.state.endDate).toDate() }}, {sort: {date: 1}}).fetch().reverse(),
		});
	}

	render() {
	    if(!this.state.flights) {
	    	return (<div>Chargement...</div>);
	    }

		return (
			<div>
				<BPanel header="Filtrer">
		            <Col sm={1}>
		              Du
		            </Col>
		            <Col sm={4}>
		              <DatePicker
                  dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
    							monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
                  id="start_date" value={this.state.startDate} onChange={(value) => this.setState({ startDate: value })}/>
		            </Col>
		            <Col sm={1}>
		              Au
		            </Col>
		            <Col sm={4}>
		              <DatePicker
                  dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
    							monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
                  id="end_date" value={this.state.endDate} onChange={(value) => this.setState({ endDate: value })} />
		            </Col>
		            <Col sm={2}>
		            	<Button onClick={::this.changeDate}>Changer</Button>
		            </Col>
				</BPanel>

				<BPanel header={ "Liste de vos vols (" + this.state.count + " vols) :"}>
		          <Table responsive>
		            <thead>
		              <tr>
		              <th>Date</th>
		              <th>Période</th>
		              <th>Status</th>
		              <th>Lieu</th>
		              <th>Actions</th>
		              </tr>
		            </thead>
		            <tbody>
		            	{this.state.flights.map((flight) =>
		            		<tr>
		            			<td>{flight.getDisplayDate()}</td>
		            			<td>{flight.getPeriod()}</td>
		            			<td>{flight.getStatus()}</td>
		            			<td>{flight.getPlace()}</td>
            					<td><Link to={'/flights/' + flight._id + '/detail'}><Button bsStyle="primary">Voir</Button></Link></td>
		            		</tr>
		            	)}
		            </tbody>
		          </Table>
				</BPanel>
		  </div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/montgolfieres/MontgolfiereView.page.js
 **/